import 'bootstrap/dist/css/bootstrap.min.css';
import Inicio from './components/Inicio';
import "./App.css"
import SobreNosotros from './components/SobreNosotros';
import Servicios from './components/Servicios';
import Llamada from './components/Llamada';
import Sistema from './components/Sistema';
//import Aumenta from './components/Aumenta';
import WhatsApp from './images/imagen-whatsapp.png'

function App() {
  return (
    <div className='fondo'>
      <Inicio className='contenedor-inicio' />
      <SobreNosotros/>
      <Servicios/>
      <Sistema/>
      {/* <Aumenta/> */}
      <Llamada/>
      <a href='https://api.whatsapp.com/send?phone=5491151127557' target='_blank' rel="noreferrer" ><img src={WhatsApp} className='botonWhatsapp' alt='WhatsApp'/></a>
    </div>
  );
}

export default App;
